import React from 'react';

const ChatbotSendIcon = ({ isLoading, isFullscreen = false }) => {
  // Всегда показываем индикатор загрузки при isLoading=true
  // независимо от того, полноэкранный режим или нет
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={`send-icon-svg ${isLoading ? 'loading' : ''}`}
    >
      {isLoading ? (
        <>
          <circle 
            cx="12" 
            cy="12" 
            r="10" 
            stroke="white" 
            strokeWidth="2" 
            strokeOpacity="0.3" 
          />
          <path 
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22"
            stroke="white" 
            strokeWidth="2" 
            strokeLinecap="round"
            className="loading-circle"
          />
        </>
      ) : (
        <path 
          d="M21.5 11.1L4.5 2.1C4.3 2 4.1 2 3.9 2.1C3.7 2.2 3.5 2.3 3.5 2.5V9.5L13.5 12L3.5 14.5V21.5C3.5 21.7 3.7 21.9 3.9 21.9C4.1 22 4.3 21.9 4.5 21.8L21.5 12.8C21.7 12.7 21.9 12.4 21.9 12.2C21.9 11.7 21.7 11.3 21.5 11.1Z"
          fill="white"
          className="send-arrow"
        />
      )}
    </svg>
  );
};

export default ChatbotSendIcon; 